/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerRightUpDouble = createReactComponent("outline", "corner-right-up-double", "IconCornerRightUpDouble", [["path", { "d": "M5 19h6a3 3 0 0 0 3 -3v-7", "key": "svg-0" }], ["path", { "d": "M10 13l4 -4l4 4m-8 -5l4 -4l4 4", "key": "svg-1" }]]);

export { IconCornerRightUpDouble as default };
//# sourceMappingURL=IconCornerRightUpDouble.mjs.map
